import React, { useState } from "react";
import { getAdminText } from "../admin/adminSozluk";

/**
 * Admin şifre ekranı.
 *
 * 2026-08-22: Ekranda artık ARAYÜZ DİLİ seçimi de var. Önce yalnız Türkçeydi ve
 * girişten sonra da dil seçimi olmadığı için İngilizce rapor almanın yolu yoktu.
 * Dil burada seçilir çünkü panele girdikten sonra değil, girmeden önce karar
 * verilir — DISC'te de böyle.
 *
 * Yanlış şifrede alert() yerine satır içi hata: alert tarayıcıyı kilitler ve
 * dile çevrilmesi de unutuluyordu.
 */
export default function AdminLogin({ onSuccess, onBack, lang = "tr", setLang }) {
  const A = getAdminText(lang);
  const [pass, setPass] = useState("");
  const [hata, setHata] = useState("");

  function handleLogin() {
    if (pass === "ajl6138") {
      onSuccess();
    } else {
      setHata(A.yanlisSifre);
    }
  }

  const dilDugmesi = (kod, etiket) => (
    <button
      key={kod}
      type="button"
      onClick={() => setLang?.(kod)}
      style={{
        ...styles.langButton,
        ...(lang === kod ? styles.langButtonActive : null),
      }}
      aria-pressed={lang === kod}
    >
      {etiket}
    </button>
  );

  return (
    <div style={styles.wrapper}>
      <div style={styles.box}>
        <p style={styles.eyebrow}>SOMEREN LABS · TA / 3 EGO</p>
        <h2 style={styles.title}>{A.girisBaslik}</h2>
        <p style={styles.subtitle}>{A.girisAciklama}</p>

        <label style={styles.label}>{A.arayuzDili}</label>
        <div style={styles.langRow}>
          {dilDugmesi("tr", "Türkçe")}
          {dilDugmesi("en", "English")}
        </div>

        <label style={styles.label}>{A.sifre}</label>
        <input
          type="password"
          autoFocus
          value={pass}
          onChange={(event) => { setPass(event.target.value); setHata(""); }}
          onKeyDown={(event) => { if (event.key === "Enter") handleLogin(); }}
          style={styles.input}
        />
        {hata ? <div style={styles.error}>{hata}</div> : null}

        <div style={styles.buttonRow}>
          <button type="button" onClick={handleLogin} style={styles.primaryButton}>
            {A.gir}
          </button>
          <button type="button" onClick={onBack} style={styles.secondaryButton}>
            {A.vazgec}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: "70vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  box: {
    width: "min(420px, calc(100vw - 40px))",
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 24,
    padding: 32,
    boxShadow: "0 18px 40px rgba(15, 23, 42, 0.08)",
  },
  eyebrow: {
    margin: 0,
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: ".1em",
    color: "#5b6473",
  },
  title: { margin: "8px 0 4px", fontSize: 20, color: "#0e2a3f" },
  subtitle: { margin: "0 0 20px", fontSize: 13, color: "#6b7280" },
  label: {
    display: "block",
    fontSize: 12,
    fontWeight: 700,
    color: "#374151",
    marginBottom: 6,
  },
  langRow: { display: "flex", gap: 8, marginBottom: 18 },
  langButton: {
    padding: "8px 18px",
    borderRadius: 999,
    border: "1px solid #d1d5db",
    background: "#fff",
    color: "#374151",
    fontWeight: 700,
    fontSize: 13,
    cursor: "pointer",
  },
  langButtonActive: {
    background: "#0e2a3f",
    borderColor: "#0e2a3f",
    color: "#fff",
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    border: "1px solid #cbd5e1",
    borderRadius: 14,
    padding: "13px 16px",
    fontSize: 16,
    color: "#111827",
    background: "#ffffff",
  },
  error: { marginTop: 8, color: "#b91c1c", fontSize: 13, fontWeight: 600 },
  buttonRow: { display: "flex", gap: 10, marginTop: 20 },
  primaryButton: {
    flex: 1,
    border: "0",
    borderRadius: 14,
    background: "#111827",
    color: "#ffffff",
    padding: "13px 16px",
    fontWeight: 900,
    cursor: "pointer",
  },
  secondaryButton: {
    border: "1px solid #d1d5db",
    borderRadius: 14,
    background: "#ffffff",
    color: "#111827",
    padding: "13px 18px",
    fontWeight: 800,
    cursor: "pointer",
  },
};
